var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loud-speaker 1",
    clipPath: "url(#clip0_3432_86430)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5 20C18.439 20 18.379 19.989 18.32 19.967L5.32 14.967C5.127 14.893 5 14.707 5 14.5V8.5C5 8.293 5.127 8.107 5.32 8.033L18.32 3.033C18.475 2.973 18.646 2.995 18.783 3.088C18.919 3.181 19 3.335 19 3.5V19.5C19 19.665 18.919 19.819 18.783 19.912C18.698 19.97 18.6 20 18.5 20ZM6 14.156L18 18.772V4.228L6 8.844V14.156Z",
    fill: "#373F41"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.5 15H2C0.897 15 0 14.103 0 13V10C0 8.897 0.897 8 2 8H5.5C5.776 8 6 8.224 6 8.5V14.5C6 14.776 5.776 15 5.5 15ZM2 9C1.448 9 1 9.448 1 10V13C1 13.552 1.448 14 2 14H5V9H2Z",
    fill: "#373F41"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.5 22H4.5C4.251 22 4.04 21.817 4.005 21.57L3.005 14.57C2.966 14.297 3.156 14.044 3.43 14.005C3.698 13.971 3.956 14.156 3.995 14.43L4.934 21H6.94L6.272 15.046C6.242 14.772 6.439 14.525 6.713 14.493C6.978 14.464 7.234 14.66 7.266 14.934L7.996 21.444C8.012 21.586 7.967 21.727 7.872 21.833C7.778 21.939 7.643 22 7.5 22Z",
    fill: "#373F41"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.5 9.00001C20.339 9.00001 20.181 8.92201 20.084 8.77701C19.931 8.54801 19.993 8.237 20.223 8.084L23.223 6.08401C23.451 5.93201 23.762 5.99201 23.916 6.22301C24.069 6.45201 24.007 6.763 23.777 6.916L20.777 8.91601C20.692 8.97301 20.596 9.00001 20.5 9.00001Z",
    fill: "#373F41"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.5 18C23.404 18 23.308 17.973 23.223 17.916L20.223 15.916C19.994 15.763 19.931 15.452 20.084 15.223C20.238 14.993 20.55 14.932 20.777 15.084L23.777 17.084C24.006 17.237 24.069 17.548 23.916 17.777C23.819 17.922 23.661 18 23.5 18Z",
    fill: "#373F41"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.5 12.5H20.5C20.224 12.5 20 12.276 20 12C20 11.724 20.224 11.5 20.5 11.5H23.5C23.776 11.5 24 11.724 24 12C24 12.276 23.776 12.5 23.5 12.5Z",
    fill: "#373F41"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3432_86430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchAds);
export default __webpack_public_path__ + "static/media/IconSearchAds.58fd706937dfbaa395fde8e34542f188.svg";
export { ForwardRef as ReactComponent };